export function RequestDetailsSkeleton() {
  return (
    <>
      {/* Close button skeleton */}
      <div className="absolute top-4 right-4 z-10 p-2">
        <div className="w-6 h-6 animate-pulse rounded bg-neutral-200" />
      </div>

      <div className="flex h-full overflow-y-auto">
        {/* Main Content Skeleton */}
        <div className="flex-1 p-12 pb-8">
          {/* Title Skeleton */}
          <div className="mb-2 h-8 w-3/4 animate-pulse rounded bg-neutral-200" />

          {/* Description Section Skeleton */}
          <div className="mb-8">
            <div className="mb-4 h-6 w-32 animate-pulse rounded bg-neutral-200" />
            <div className="space-y-2">
              <div className="h-4 w-full animate-pulse rounded bg-neutral-200" />
              <div className="h-4 w-5/6 animate-pulse rounded bg-neutral-200" />
              <div className="h-4 w-4/5 animate-pulse rounded bg-neutral-200" />
            </div>
          </div>

          {/* Comments Section Skeleton */}
          <div className="mb-8">
            <div className="mb-4 h-6 w-24 animate-pulse rounded bg-neutral-200" />
            <div className="space-y-4">
              {[1, 2, 3].map((i) => (
                <div key={i} className="border-neutral-200 border-t pt-4">
                  <div className="mb-2 flex items-center space-x-3">
                    <div className="h-8 w-8 animate-pulse rounded-full bg-neutral-200" />
                    <div className="h-4 w-24 animate-pulse rounded bg-neutral-200" />
                    <div className="h-4 w-16 animate-pulse rounded bg-neutral-200" />
                  </div>
                  <div className="space-y-2">
                    <div className="h-4 w-full animate-pulse rounded bg-neutral-200" />
                    <div className="h-4 w-3/4 animate-pulse rounded bg-neutral-200" />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Events Section Skeleton */}
          <div className="border-neutral-200 border-t pt-2">
            <div className="mb-4 h-6 w-32 animate-pulse rounded bg-neutral-200" />
            <div className="space-y-3">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="flex items-center space-x-3">
                  <div className="h-2 w-2 animate-pulse rounded-full bg-neutral-200" />
                  <div className="h-4 w-32 animate-pulse rounded bg-neutral-200" />
                  <div className="h-4 w-24 animate-pulse rounded bg-neutral-200" />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Sidebar Skeleton */}
        <div className="w-80 border-neutral-200 border-l bg-neutral-50 p-6">
          <div className="space-y-6">
            {/* Status Skeleton */}
            <div>
              <div className="mb-2 h-4 w-16 animate-pulse rounded bg-neutral-200" />
              <div className="h-10 w-full animate-pulse rounded bg-neutral-200" />
            </div>

            {/* Owner Skeleton */}
            <div>
              <div className="mb-2 h-4 w-16 animate-pulse rounded bg-neutral-200" />
              <div className="h-10 w-full animate-pulse rounded bg-neutral-200" />
            </div>

            {/* Type Skeleton */}
            <div>
              <div className="mb-2 h-4 w-16 animate-pulse rounded bg-neutral-200" />
              <div className="h-10 w-full animate-pulse rounded bg-neutral-200" />
            </div>

            {/* Request Info Skeleton */}
            <div className="space-y-3">
              <div className="h-4 w-20 animate-pulse rounded bg-neutral-200" />
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="flex justify-between">
                  <div className="h-4 w-16 animate-pulse rounded bg-neutral-200" />
                  <div className="h-4 w-20 animate-pulse rounded bg-neutral-200" />
                </div>
              ))}
            </div>

            {/* Actions Skeleton */}
            <div className="pt-4">
              <div className="h-10 w-full animate-pulse rounded bg-neutral-200" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
